import * as React from 'react';
import { BaseMessageDTO } from '../modules/embed/models/assistant';

interface ModalContextProps {
  isOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
  setDataItemMessage: React.Dispatch<
    React.SetStateAction<BaseMessageDTO | null>
  >;
  dataItemMessage: BaseMessageDTO | null;
}

export const ModalContext = React.createContext<ModalContextProps | undefined>(
  undefined,
);

export const ModalProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [dataItemMessage, setDataItemMessage] =
    React.useState<BaseMessageDTO | null>(null);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  return (
    <ModalContext.Provider
      value={{
        isOpen,
        openModal,
        closeModal,
        setDataItemMessage,
        dataItemMessage,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};

export const useModal = (): ModalContextProps => {
  const context = React.useContext(ModalContext);
  if (!context) {
    throw new Error('useModal deve ser usado dentro de um ModalProvider');
  }
  return context;
};
